const MODES = new Set(['auto', 'high', 'low']);
const SLOW_EFFECTIVE_TYPES = new Set(['slow-2g', '2g', '3g']);
export function isViewerQualityMode(value) {
    return typeof value === 'string' && MODES.has(value);
}
export function resolveViewerQualityOptions(input) {
    const params = new URLSearchParams(input.search);
    const tune = params.get('viewerQualityTune') ?? undefined;
    const param = params.get('viewerQuality');
    if (param !== null && isViewerQualityMode(param) && param !== 'auto') {
        return { mode: param, initial: param, source: 'url', tune };
    }
    const urlAuto = param === 'auto';
    const stored = input.storedMode;
    if (!urlAuto && isViewerQualityMode(stored) && stored !== 'auto') {
        return { mode: stored, initial: stored, source: 'stored', tune };
    }
    const remembered = input.remembered;
    if (remembered !== undefined &&
        (remembered.quality === 'high' || remembered.quality === 'low') &&
        input.nowMs - remembered.atMs >= 0 &&
        input.nowMs - remembered.atMs <= input.memoryTtlMs) {
        return {
            mode: 'auto',
            initial: remembered.quality,
            source: 'remembered',
            tune,
        };
    }
    if (input.effectiveType !== undefined &&
        SLOW_EFFECTIVE_TYPES.has(input.effectiveType)) {
        return { mode: 'auto', initial: 'low', source: 'connection', tune };
    }
    return { mode: 'auto', initial: 'high', source: 'default', tune };
}
/** Browser inputs the service cannot get from its store: URL + connection hint. */
export function readViewerQualityEnvironment() {
    let search = '';
    let effectiveType;
    try {
        search = window.location.search;
        const connection = navigator.connection;
        effectiveType = connection?.effectiveType;
    }
    catch {
        // no window: defaults
    }
    return { search, effectiveType };
}
